import type { CustomTestWizardMode } from 'pages/custom_tests/types';

/**
 * Steps of the Custom Test authoring wizard. Smart Build only participates in the
 * from-scratch create flows; Copy and Edit skip it (per Custom Tests 2.0 rules).
 */
export enum EWizardStep {
    DETAILS = 'details',
    SMART_BUILD = 'smartBuild',
    QUESTIONS = 'questions',
    SETTINGS = 'settings',
    SUMMARY = 'summary'
}

export enum EWizardMode {
    TRAINING = 1,
    TESTING = 2,
    BOTH = 3
}

/**
 * Ordered list of steps for a given wizard mode. This is the single source of truth
 * for navigation, the step indicator, and next/back transitions.
 *
 * Smart Build is additionally gated behind the `Admin.CustomTest.SmartBuild` feature
 * flag: when the flag is off the step is dropped entirely, so it is never shown or
 * stepped through during the create process.
 */
export const getStepsForMode = (mode: CustomTestWizardMode, smartBuildEnabled: boolean): EWizardStep[] => {

    const withSmartBuild = smartBuildEnabled && (mode === 'create-smart' || mode === 'create-manual');

    return withSmartBuild
        ? [EWizardStep.DETAILS, EWizardStep.SMART_BUILD, EWizardStep.QUESTIONS, EWizardStep.SETTINGS, EWizardStep.SUMMARY]
        : [EWizardStep.DETAILS, EWizardStep.QUESTIONS, EWizardStep.SETTINGS, EWizardStep.SUMMARY];

};

/**
 * True when Save should create a new record (create/copy) rather than update an
 * existing one (edit). Copy always saves as a brand-new, independently owned test.
 */
export const isCreateMode = (mode: CustomTestWizardMode): boolean => mode !== 'edit';
